import production from './production';
import staging from './staging';
import test from './test';

export default {
  production,
  staging,
  test,
};
